import { useContext } from 'react';

import { BonusCashConfigContext } from '../components';

export const useBonusCashConfig = () => useContext(BonusCashConfigContext);
